import React from "react";

import { AlgoliaIndexName } from "@utils/enums";
import { attemptMethod } from "@utils/general";

import {
    SearchIndexContext,
    SearchIndexContextProvider,
} from "@context/searchIndex.context";

import { ProductAlgoliaModel } from "lib/@types/service/product/algolia/product.algolia.model";

import AutocompleteSearchBox from "./AutocompleteSearchBox/autocompleteSearchBox.container";

export type SearchAutocompleteWrapperProps = {
    indexes: string;
    searchPath: string;
    initialProducts?: Array<ProductAlgoliaModel>;
};

const SearchAutocompleteWrapper = ({
    indexes,
    searchPath,
    initialProducts,
}: SearchAutocompleteWrapperProps) => {
    const parsedIndexes = attemptMethod(() => JSON.parse(indexes), {});

    if (Object.keys(parsedIndexes).length === 0) {
        return null;
    }

    const searchIndexContextValue: SearchIndexContext = {
        productsIndex: parsedIndexes[AlgoliaIndexName.Products],
        contentPagesIndex: parsedIndexes[AlgoliaIndexName.ContentPages],
        querySuggestionsIndex: parsedIndexes[AlgoliaIndexName.QuerySuggestions],
    };

    return (
        <SearchIndexContextProvider {...searchIndexContextValue}>
            <AutocompleteSearchBox
                searchPath={searchPath}
                initialProducts={initialProducts}
            />
        </SearchIndexContextProvider>
    );
};

export { SearchAutocompleteWrapper };
